<template>
    <div class="order-info">
        <table class="table">
            <tr>
                <th>一级产品</th>
                <th>二级产品</th>
                <th>三级产品</th>
                <th>服务类型</th>
                <th>品牌</th>
                <th>系列</th>
                <th>数量</th>
            </tr>
            <tr v-for="(item,index) in tableData" :key="index">
                <td :title="item.ProductCategoryName">{{item.ProductCategoryName}}</td>
                <td :title="item.TwoProductCategoryName">{{item.TwoProductCategoryName}}</td>
                <td :title="item.ThreeProductCategoryName">{{item.ThreeProductCategoryName}}</td>
                <td :title="item.ServiceStageName">{{item.ServiceStageName}}</td>
                <td :title="item.BrandName">{{item.BrandName}}</td>
                <td :title="item.SeriesName">{{item.SeriesName}}</td>
                <td>{{item.Count}}</td>
            </tr>
        </table>
        <ul class="list">
            <li class="block" v-if="jobInfo.IndustryName">
                <div class="label">所属行业：</div>
                <div class="value">{{jobInfo.IndustryName }}</div>
            </li>
            <li v-if="jobInfo.EngineerCount">
                <div class="label">所需工程师数量：</div>
                <div class="value">{{jobInfo.EngineerCount }}</div>
            </li>
            <li v-if="jobInfo.SecondLinkMan">
                <div class="label">您的称呼：</div>
                <div class="value">{{jobInfo.SecondLinkMan}}</div>
            </li>
            <li v-if="jobInfo.SecondHandSet">
                <div class="label">您的联系方式：</div>
                <div class="value">{{jobInfo.SecondHandSet}}</div>
            </li>
            <li class="block" v-if="jobInfo.Symptom">
                <div class="label">故障现象：</div>
                <div class="value">{{jobInfo.Symptom}} </div>
            </li>
            <li class="block" v-if="jobInfo.Content">
                <div class="label">服务需求描述：</div>
                <div class="value">{{jobInfo.Content }}</div>
            </li>
            <template v-if="ExtendFieldList.length != 0">
                <li v-for="(item,i) in ExtendFieldList" :key="i">
                    <div class="label">{{item.FieldName}}：</div>
                    <div class="value">{{item.FieldValue}}</div>
                </li>
            </template>
            <li class="block">
                <div class="label">现场资料：</div>
                <div class="value" v-if="fileList.length != 0">
                    <div v-for="(item,index) in fileList" :key="index" class="icon-doc">
                        <a v-if="item.FileType==2" href="javascript:void(0)" class="link">
                            <img class="pic" :src="item.FileUrl" preview="1" :preview-text="item.FileName" alt="">
                        </a>
                        <a v-if="item.FileType==1" :href="item.FileUrl" class="link">
                            <img class="pic" :src="item.IconUrl" alt="">
                        </a>
                    </div>
                </div>
                <div class="value" v-else>无</div>
            </li>
            <li class="block" v-if="baseInfo.JobServiceContract&&baseInfo.JobServiceContract.IsSign">
                <div class="label">服务合同：</div>
                <div class="value" >
                    <div  class="icon-doc"> 
                        <a :href="baseInfo.JobServiceContract.ContractFileUrl" class="link" target="_blank">
                            <img class="pic" src="http://api.insupai.com/Image/pdf.png" alt="">
                        </a>
                    </div>
                </div> 
            </li>
            <!-- <li>
                <div class="label">工程师资质要求：</div>
                <div class="value">{{jobInfo.Aptitude }}</div>
            </li>
            <li>
                <div class="label">工具及备件：</div>
                <div class="value">{{jobInfo.JobTool }}</div>
            </li>
            <li>
                <div class="label">备注：</div>
                <div class="value">{{jobInfo.Remark}}</div>
            </li> -->
            
            <!-- <li v-if="specialList.length">
                <div class="label">特殊说明：</div>
                <ul class="instructions">
                    <template v-for="item in specialList" >
                        <li :key="item.ID">
                            <div class="instruction">{{item.Name}}</div>
                            <div class="desc">{{item.Remark}}</div>
                        </li>
                    </template>
                </ul>
            </li> -->
        </ul>
        <div class="special-int" v-if="specialList.length">
            <div class="min-titel">特殊说明</div>
            <ul class="special-list">
                <li v-for="(item, index) in specialList" :key="index">
                    <div class="special-title">{{item.Title}}</div>
                    <div class="special-content">
                        <span v-for="(items,indexs) in item.ProblemOptionList" :key="indexs">{{items.Content}}<i>；</i></span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import {GetJobInfo} from '@/scripts/api'
// import { observable } from 'vue/types/umd';
export default {
    data(){
        return{
            jobNo:'',
            jobInfo:{},
            fileList:[],
            tableData:[],
            ExtendFieldList:[],
            specialList:[],
            showInput:true,
        }
    },
    props:{
        baseInfo:{
          type: Object
        }
    },
    created() {
        this.jobNo=this.$route.query.jobNo;
        this.init();
    },
    mounted(){
        // console.log("baseInfo:"+JSON.stringify(this.baseInfo));
    },
    methods: {
        init(){
            GetJobInfo({jobNo:this.jobNo}).then(r=>{
                if(r.Result==1){
                    this.jobInfo=r.Data;
                    this.fileList=r.Data.FileList || [];
                    this.tableData=r.Data.ProductLineList || [];
                    this.ExtendFieldList = r.Data.ExtendFieldList || [];
                    // this.specialList= r.Data.SpecialRemarkList || [];
                    this.specialList= r.Data.ServiceProblemList || [];
                    this.$nextTick(()=>{
                        this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
                    })
                }
            })
        },
        // upload(){
        //     $.ajaxFileUpload({
        //         url:'/api/Upload/UploadImg',
        //         secureuri:false,
        //         fileElementId:'fileBtn',
        //         dataType: 'json',
        //         success: function (data,status){
        //             console.log(data);
        //         },
        //         error:function (data,status,e) {
        //             console.log(e);
        //         }
        //     })
        // }
    },
}
</script>
<style lang="scss">
.order-info{
    width: 840px;
    padding-top: 50px;
    padding-bottom: 50px;
    .table{
        width: 100%;
        font-size: 14px;
        border-collapse: collapse;
        background-color: #fff;
        text-align: center;
        margin-bottom: 20px;
        tr{
            border: 1px solid #e5e5e5;
            &:first-child{
                background-color: #f9f9f9;
            }
        }
        th{
            height: 48px;
            color: #999;
        }
        td{
            height: 48px;
            color: #333;
        }
    }
    .list{
        overflow: hidden;
        >li{
            float: left;
            min-width: 368px;
            margin-bottom: 10px;
            &.block{
                width: 100%;
            }
        }
        .label{
            width: 126px;
            font-size: 14px;
            color: #666;
            line-height:24px;
            float: left;
        }
        .value{
            font-size: 14px;
            color: #333;
            line-height:24px;
            float: left;
            word-break: break-all;
            width: calc(100% - 126px);
        }
        .icon-doc{
            display: inline-block;
            width: 124px;
            height: 124px;
            vertical-align: middle;
            margin-right: 40px;
            position: relative;
            background-color: #f8f8f8;
        }
        .pic{
            position: absolute;
            left: 50%;
            top: 50%;
            transform:translate(-50%,-50%);
            max-width: 100%;
            max-height: 100%;
        }
    }
    .instructions{
        float: left;
        width: 840px;
        overflow: hidden;
        padding-top: 1px;
        margin-top: 10px;
        >li{
            float: left;
            width: 50%;
            border: 1px solid #e5e5e5;
            padding: 10px;
            margin-top: -1px;
            &:nth-child(even){
                float: right;
                margin-left: -1px;
            }
        }
        .instruction{
            font-size: 14px;
            color: #333;
            line-height: 24px;
            margin-bottom: 4px;
        }
        .desc{
            font-size: 14px;
            color: #999;
            line-height: 24px;
        }
    }


    // 特殊说明
    .special-int {
        margin-top: 36px;
        .min-titel {
            width: 840px;
            height: 48px;
            background: #F9F9F9;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 48px;
            text-align: center;
            margin-bottom: 30px;
        }
        .special-list {
            li {
                // padding-top: 20px;
                padding-bottom: 20px;
                .special-title {
                    font-size: 14px;
                    font-weight: 400;
                    color: #666666;
                    line-height: 16px;
                    padding-bottom: 10px;
                }
                .special-content {
                    font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 16px;
                    span:last-child{
                        i{
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>